export default "__VITE_ASSET__Tkn41tom__"